export default __webpack_public_path__ + "static/media/tahoe-Ikge1ZIk9yc-unsplash.926f94ef.jpg";